export const isEv = (text: string) => {
  return /^E|E$/g.test(text)
}
